// Re-export apiClient from the main api service
import { apiClient } from './api';
export { apiClient };
export default apiClient;
